import { useElementPosition } from '@trg/utils';

export function useEventsVisibiity() {
  const elementPosition = useElementPosition(
    { current: document.body },
    { throttle: true, delay: 1500 }
  );
  if (!elementPosition) return false;

  const { y, direction } = elementPosition;
  return y + 500 > 0 || direction === 'up';
}
